import { NgModule } from '@angular/core';

import { ReportListComponent } from './report-list/report-list.component';
import { SharedModule } from '@app/shared';
import { ReportDialogComponent } from './report-dialog/report-dialog.component';


@NgModule({
  declarations: [
    ReportListComponent,
    ReportDialogComponent
  ],
  imports: [
    SharedModule
  ]
})
export class ReportsModule { }
